// Avoid `console` errors in browsers that lack a console.
(function() {
    var method;
    var noop = function () {};
    var methods = [
        'assert', 'clear', 'count', 'debug', 'dir', 'dirxml', 'error',
        'exception', 'group', 'groupCollapsed', 'groupEnd', 'info', 'log',
        'markTimeline', 'profile', 'profileEnd', 'table', 'time', 'timeEnd',
        'timeline', 'timelineEnd', 'timeStamp', 'trace', 'warn'
    ];
    var length = methods.length;
    var console = (window.console = window.console || {});

    while (length--) {
        method = methods[length];

        // Only stub undefined methods.
        if (!console[method]) {
            console[method] = noop;
        }
    }
}());

(function( $ ) {
  $( document ).ready( function() {

    // -------------------------------------
    // Background video player
    // -------------------------------------

    $("#bgndVideo").YTPlayer();

    // -------------------------------------
    // Fixed header
    // -------------------------------------


// Initial state
var scrollPos = 0;
var scrollStatePrevious = "up";
var scrollState = "";
// adding scroll event
window.addEventListener('scroll', function(){
  // detects new state and compares it with the new one
  var st = window.pageYOffset || document.documentElement.scrollTop;

  if (st > scrollPos){
    scrollState = "down";
  }
  else {
    scrollState = "up";
  }

  if (st == 0 ){
    $('#header').removeClass('fixed');
  }

  if( scrollStatePrevious != scrollState ){
    if( scrollState == "up" ){
      $('#header').show();
      $('#header').addClass('fixed');
    }
    if( scrollState == "down" ){
      $('#header').hide();
      $('#header').removeClass('fixed');
    }

    scrollStatePrevious = scrollState;
  }

  // saves the new position for iteration.
  scrollPos = st <= 0 ? 0 : st; // For Mobile or negative scrolling
});

    // -------------------------------------
    // Hamburger menu
    // -------------------------------------

    // Create a new instance of Slidebars
    var controller = new slidebars();

    // Initialize Slidebars
    controller.init();

    $( '.js-hamburger' ).on( 'click', function ( event ) {
        event.stopPropagation();
        controller.toggle( 'slidebar' );
        return false;
    } );

    // -------------------------------------
    // ScrollTo (click on link)
    // -------------------------------------

    var currentLocation = window.location;

    if( currentLocation.hash != "" ){
      scroll(0,0);
      setTimeout(function(){scroll(0,0);},1);

      setTimeout(function(){
        $.scrollTo(currentLocation.hash, 800, {
            axis: "y"
        });
      }, 500);
    }

    $("a[href^='#']").click(function () {
        var thisHref = $(this).attr("href");

        $.scrollTo(thisHref, 800, {
            axis: "y"
        });

        return false;
    });

    $(".js-hover").hover(
      function () {
          $(this).addClass("is-hover");
      },
      function () {
          $(".js-hover").removeClass("is-hover");
      }
    );

    // -------------------------------------
    // Reference slider
    // -------------------------------------

    if ($(".js-slider").length) {
      new Glide('.js-slider', {
        type: "carousel",
        focusAt: "center",
        perView: 3,
        peek: -200,
        gap: 30,
        //autoplay: 4000,
        hoverpause: true,
        breakpoints: {
          1800: {
            perView: 1,
            peek: 400
          },
          1500: {
            perView: 1,
            peek: 200
          },
          768: {
            perView: 1,
            peek: 50
          },
          468: {
            perView: 1,
            peek: 10
          }
        }
      }).mount();
    }

    // -------------------------------------
    // Checkout slider gallery
    // -------------------------------------

    if ($(".js-gallery").length) {
      new Glide('.js-gallery', {
        type: "carousel",
        focusAt: "center",
        perView: 1,
        autoplay: 2000,
        gap: 0,
        animationDuration: 2000,
        rewindDuration: 2000,
        hoverpause: true
      }).mount();
    }

    // -------------------------------------
    // Border line color
    // -------------------------------------

    $(".drc-list__item").each(function(){
      var termsBgColor = $(this).find(".drc-list__item__terms a:last-child").css("backgroundColor");
      $(this).find(".drc-list__item__terms").css("borderColor", termsBgColor);
    });

    // -------------------------------------
    // Animate page elements
    // -------------------------------------

    var wow = new WOW(
      {
        boxClass:     'wow',      // animated element css class (default is wow)
        animateClass: 'animated', // animation css class (default is animated)
        offset:       0,          // distance to the element when triggering the animation (default is 0)
        mobile:       false,       // trigger animations on mobile devices (default is true)
        live:         true,       // act on asynchronously loaded content (default is true)
        callback:     function(box) {
          // the callback is fired every time an animation is started
          // the argument that is passed in is the DOM node being animated
        },
        scrollContainer: null,    // optional scroll container selector, otherwise use window,
        resetAnimation: true,     // reset animation on end (default is true)
      }
    );
    wow.init();

  });
})( jQuery );
